import { render, staticRenderFns } from "./service-hooks-configuration.component.vue?vue&type=template&id=3be5b9d3&scoped=true&"
import script from "./service-hooks-configuration.component.vue?vue&type=script&lang=ts&"
export * from "./service-hooks-configuration.component.vue?vue&type=script&lang=ts&"
import style0 from "./service-hooks-configuration.component.vue?vue&type=style&index=0&id=3be5b9d3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be5b9d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VRow})
